export default __webpack_public_path__ + "static/media/4.75fd8c9b.jpg";